export function Divider() {
  return (
    <hr
      aria-hidden
      className="h-px border-0 bg-line md:bg-transparent md:bg-gradient-to-r md:from-primary md:via-line md:to-primary"
    />
  );
}

export function SectionDivider() {
  return (
    <div className="md:my-14 md:px-6">
      <div className="mx-auto max-w-6xl">
        <Divider />
      </div>
    </div>
  );
}
